import { CommonModule } from '@angular/common';
import { APP_INITIALIZER, InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { MojoAvatarModule } from 'mojo-avatar';
import { first, switchMap } from 'rxjs/operators';

import {
  NotificationLicenses,
  NotificationLicenseType,
} from '@collections/notifications/notification.config';
import * as NotificationsActions from '@collections/notifications/notifications.actions';
import { getUsersLoggedIn } from '@collections/users';
import { loadLicenseExtensions } from '@core/settings/license-configuration';
import { MaterialModule } from '@material/material.module';
import { isTruthy } from '@shared';
import { DropdownModule } from '@shared/dropdown/dropdown.module';
import { TimeDiffModule } from '@shared/time-diff/time-diff.module';

import { NotificationItemComponent } from './components/notification-item/notification-item.component';
import { NotificationsLoaderComponent } from './components/notification-loader/notifications-loader.component';
import { NotificationsBellContainerComponent } from './containers/notifications-bell/notifications-bell.container';
import { NotificationsContainerComponent } from './containers/notifications/notifications.container';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

export function initializeNotifications(store: Store) {
  return async () => {
    store
      .pipe(
        select(getUsersLoggedIn),
        first(isTruthy),
        switchMap(() =>
          store.select(loadLicenseExtensions).pipe(first((extenstion) => extenstion.length > 0)),
        ),
      )
      .subscribe(() => {
        store.dispatch(NotificationsActions.notificationsLoadPage({}));
      });
  };
}
export const NOTIFICATION_LICENSES = new InjectionToken<NotificationLicenseType>(
  'NotificationLicenses',
);

const components = [
  NotificationsContainerComponent,
  NotificationsBellContainerComponent,
  NotificationItemComponent,
  NotificationsLoaderComponent,
];

@NgModule({
  declarations: [...components],
  exports: [...components],
  imports: [
    CommonModule,
    MaterialModule,
    TimeDiffModule,
    DropdownModule,
    MojoAvatarModule,
    RouterModule,
    InfiniteScrollModule,
    MatMenuModule,
  ],
})
export class NotificationsModule {
  static forRoot(): ModuleWithProviders<NotificationsModule> {
    return {
      ngModule: NotificationsModule,
      providers: [
        {
          provide: APP_INITIALIZER,
          multi: true,
          useFactory: initializeNotifications,
          deps: [Store],
        },
        {
          provide: NOTIFICATION_LICENSES,
          useValue: NotificationLicenses,
        },
      ],
    };
  }
}
